import type { FetchChargeTypesQuery } from '@/features/charge-types/api'
import type { ChargeTypesSearch } from '@/routes/_protected/$tenantKey/settings/_system-master-settings/charge-types/-models/charge-types-search'

export function buildFetchChargeTypesQuery(
  tenantKey: string,
  deps: ChargeTypesSearch
): FetchChargeTypesQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
